<template>
    <div class="box">
        <div class="box-offset">
            <div class="box-ttl-wrap">
                <div class="box-ttl">
                    Availability
                </div>
                <div class="box-ttl-info-block">
                    <div>
                        <b>Last updated:</b> {{ calculateDate(dataFormAvailability.updated_at) }}
                    </div>
                    <div class="d-flex">
                        <b>Hide from Standby List:</b>
                        <VueToggles
                            height="30"
                            width="80"
                            font-size="14"
                            checkedBg="#60ad45"
                            uncheckedBg="#e0e1e2"
                            :value="dataFormAvailability.hide_stand_by"
                            @click="switchStatus('stand')"
                        />
                    </div>
                    <div class="d-flex">
                        <b>Hide Shift Board:</b>
                        <VueToggles
                            height="30"
                            width="80"
                            font-size="14"
                            checkedBg="#60ad45"
                            uncheckedBg="#e0e1e2"
                            :value="dataFormAvailability.hide_shift_board"
                            @click="switchStatus('shift')"
                        />
                    </div>
                </div>
            </div>
            <ValidationObserver ref="form" class="form">
                <div class="row">
                    <AvailabilityForm
                        @data-changed="updateForm"
                        :user="userInfo"
                        class="col-lg-12"
                    ></AvailabilityForm>

                    <div class="col-12">
                        <div class="btns-wrap">
                            <button
                                @click="window.history.back()"
                                class="btn btn--outline-primary w-100 w-sm-auto"
                            >
                                Cancel
                            </button>
                            <button
                                @click="save"
                                class="btn btn--secondary w-100 w-sm-auto"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
import AvailabilityForm from "../../../../AppUser/resources/js/CommonForms/AvailabilityForm.vue";
import EmployeeInfoService from "../../../../AppUser/resources/js/services/EmployeeInfoService";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";

export default {
    name: 'Availability',
    components: {AvailabilityForm},
    mixins: [DateConverter],
    props: {
        userInfo: {
            type: Object
        }
    },
    data() {
        return {
            dataFormAvailability: {
                start_date: null,
                night: [],
                morning: [],
                afternoon: [],
                time_absence: null,
                updated_at: null,
                hide_stand_by: null,
                hide_shift_board: null,
            },
            userInfoLoaded: false

        }
    },

    methods: {
        async save() {
            this.$showLoadingMessage()
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showErrorMessage();
                return;
            }
            try {
                const response = await EmployeeInfoService.updateAvailabilityForm(this.userInfo.id, this.dataFormAvailability);
                if (response.status === 200) {
                    this.$showSuccessMessage('Your information has been updated');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000)
                }
            } catch (error) {
                this.$showErrorMessage('Your information has not been saved. Please try again.');
            }
        },
        switchStatus(field) {
            if (field === 'stand') {
                this.dataFormAvailability.hide_stand_by = !this.dataFormAvailability.hide_stand_by
            } else if (field === 'shift') {
                this.dataFormAvailability.hide_shift_board = !this.dataFormAvailability.hide_shift_board
            }
        },
        updateForm(dataAvailabilityForm) {
            this.dataFormAvailability = dataAvailabilityForm;
        }
    },
    mounted() {
        Object.assign(this.dataFormAvailability, this.userInfo.availability);
        this.dataFormAvailability.hide_stand_by = Boolean(this.userInfo.hide_stand_by)
        this.dataFormAvailability.hide_shift_board = Boolean(this.userInfo.hide_shift_board)
    },
}

</script>

<style scoped>

</style>
